import makeStyles from '@mui/styles/makeStyles';
import { alpha, lighten } from '@mui/material/styles';
export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
  },
  title: {
    margin: 0,
    paddingTop: theme.spacing(2),
    lineHeight: 1.2,
    fontWeight: 'bold',
  },
  content: {
    flexGrow: 1,
    overflowY: 'auto',
  },
  paddingTopBottom: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  paddingBottom: {
    paddingBottom: theme.spacing(1),
  },
  imagesContainer: {
    '& [type=secondarySub]': {
      marginBottom: theme.spacing(1),
    },

    '& .imagesList': {
      flexWrap: 'wrap',
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
    },

    '& .IMAGE': {
      paddingRight: theme.spacing(1),
    },
  },
  rowOutline: {
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
    padding: `${theme.spacing(2)} 0`,
    float: 'left',
    width: '100%',
  },

  showWrap: {
    margin: `${theme.spacing(1)} 0`,
    '& .MuiToggleButtonGroup-root': {
      marginLeft: theme.spacing(1),
      '& button': {
        padding: `0px 5px`,
      },
    },
  },

  commentContainer: {
    width: '100%',
    marginTop: theme.spacing(),
    minHeight: theme.spacing(4),
  },
  commentWrapTitle: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  commentCount: {
    fontSize: 13,
    marginLeft: theme.spacing(1),
  },
  commentBtnContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  commentBtn: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  createCommentContainer: {
    position: 'relative',
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.action.disabledBackground}`,
    width: (p) => (p.isMobile ? `calc(100% + 76px)` : '100%'),
    marginLeft: (p) => (p.isMobile ? '-38px' : 'auto'),
    marginRight: (p) => (p.isMobile ? '-38px' : 'auto'),
    marginTop: theme.spacing(2),

    '& .titleContainer': {
      margin: 0,

      '& h4': {
        fontSize: 16,
        fontWeight: 'bold',
      },
    },
  },

  createCommentContainerMobile: {
    '& .titleContainer': {
      margin: 0,

      '& h4': {
        fontSize: 16,
        fontWeight: 'bold',
      },
    },
  },
  cancelButton: {
    backgroundColor: theme.colors.red,
    '&:hover': {
      backgroundColor: lighten(theme.colors.red, 0.1),
    },
  },
  submitButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',

    '& button': {
      marginRight: 0,
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(2),
    },
  },
}));
